import config from 'config';
import clientId from 'clientId';
import request from 'superagent';

export default ({
  email,
}) => {
  const {access_token} = localStorage;
  return request.post(config.eadmin.baseUrl + '/graphql')
    .query({
      access_token,
      raw: true,
    })
    .send({
      query: `mutation (
          $email: String!
        ) {
          enableUser (
            email: $email
            clientId: "${clientId}"
          )
        }`,
      variables: {email: email}
    })
    .endAsync()
    .get('body')
    .then((res) => {
      localStorage.access_token = res.data.enableUser;
    });
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/enableUserAsync.js
 **/